/**
 * Admin Travel／Ads 頁面共用：安全錯誤文案與 request 世代 guard。
 */

/**
 * 判斷是否為不可直接顯示給操作者的技術性錯誤字串（Axios／stack／英文 status）。
 * @param {string} msg
 * @returns {boolean}
 */
function isUnsafeTechnicalMessage(msg) {
  if (!msg) return true;
  if (msg.length > 240) return true;
  if (/Exception|SQLSyntax|NullPointer|at\s+[\w.$]+\(|Caused by:|stack trace/i.test(msg)) {
    return true;
  }
  // Axios／XHR 常見英文原文，不得進 UI
  if (
    /^Network Error$/i.test(msg)
    || /^timeout of \d+ms exceeded$/i.test(msg)
    || /Request failed with status code \d+/i.test(msg)
    || /^ERR_[A-Z0-9_]+$/i.test(msg)
    || /AxiosError/i.test(msg)
  ) {
    return true;
  }
  return false;
}

export function toSafeErrorMessage(err, fallback) {
  const msg = String(err?.message || '').trim();
  if (isUnsafeTechnicalMessage(msg)) return fallback;
  return msg;
}

export function createRequestGuard() {
  let seq = 0;
  return {
    next() {
      seq += 1;
      return seq;
    },
    isCurrent(token) {
      return token === seq;
    },
  };
}
